export default "__VITE_ASSET__dq2wdRoZ__"